var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-bell",
    clipPath: "url(#clip0_19046_7721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.42383 21C7.81149 21.8914 8.45106 22.6502 9.26398 23.1831C10.0769 23.716 11.0278 23.9999 11.9998 23.9999C12.9719 23.9999 13.9228 23.716 14.7357 23.1831C15.5486 22.6502 16.1882 21.8914 16.5758 21H7.42383Z",
    fill: "#A7A7A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.3918 12.5497L20.6558 6.82666C20.0999 4.82501 18.8912 3.06644 17.2217 1.83016C15.5522 0.593891 13.5175 -0.0492201 11.4407 0.00294028C9.36396 0.0551007 7.36413 0.799543 5.75878 2.11807C4.15342 3.43659 3.03455 5.25362 2.57981 7.28066L1.23181 12.8177C1.05264 13.5534 1.04293 14.3203 1.20342 15.0603C1.3639 15.8004 1.69039 16.4943 2.15823 17.0897C2.62607 17.6852 3.22306 18.1666 3.90412 18.4976C4.58519 18.8287 5.33255 19.0007 6.08981 19.0007H17.6068C18.3875 19.0007 19.1574 18.8179 19.8548 18.4669C20.5522 18.1159 21.1577 17.6065 21.6228 16.9794C22.088 16.3523 22.3998 15.6251 22.5333 14.8558C22.6668 14.0866 22.6184 13.2968 22.3918 12.5497Z",
    fill: "#A7A7A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19046_7721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.d1a911f8dbca08f90473ad7fbb1fde93.svg";
export { ForwardRef as ReactComponent };